
<script>

  import {
    mapGetters,
    mapActions
  } from "vuex";
  
  import _ from "lodash";

  import { supabase } from "../../libs/supabaseClient";

  import _system from '../../libs/system';
  import iziToast from 'izitoast'
  import 'izitoast/dist/css/iziToast.min.css';
import Axios from 'axios';

export default {
   name: "campaign",
   data() {
      return {
         searchQuery: '',
         campaigns: [],
         templates: [],
         numbers: [],
         campaign: {
            name: '',
            segment: '',
            message: "Celebrate love with our exquisite jewelry collection this Valentine's Day! From stunning diamond rings to elegant necklaces, we have the perfect piece to make your loved one feel special. Shop now and give the gift of timeless beauty. ❤️💍 #ValentinesDay #JewelryLove",
            scheduled: 'Now',
            platform: '',
         },
         modals: {
            campaign: false,
            details: false
         }
      }
   },
   computed: {
   ...mapGetters('session', ['isLoggedIn', 'getUser', 'getWhiteLabel']),
   ...mapGetters('accounts', ['accounts']),
   ...mapGetters('networks', ['networks','networksByName']),
   ...mapGetters("workspaces", ["workspaces", "currentWorkspace", "workspacesByUser"]),
   ...mapGetters('contacts', ['contacts']),
   },
   methods: {
   ...mapActions("session", ["setUser"]),
   ...mapActions("htmlModals", ["setEditUser"]),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),
      campaignResults(){
        this.modals.details = true;
      },
      openTemplates(){
         this.numbers =  _.filter(this.accounts, (e) => { return e.platform == this.networksByName['WhatsApp']._id });
         
         if(!this.numbers.length){
            return alert('Please connect at least one WhatsApp number.');
         }

         //127.0.0.1:5555
         //https://widget.juphy.com
         Axios.get('https://widget.juphy.com/whatsapp/templates/' + this.numbers[0]._id)
         .then(response => {
            console.log(response.data);
            this.templates = response.data;
            this.modals.campaign = true;
         })
         .catch(error => {
            console.log(error.data)
            return console.log({err: true, message: "cant fetch templates"});
         });
      },
      createCampaign(){

         if(!this.campaign.name.length){
            return alert('Please, type a name for your campaign.');
         }

         let currentTemplate = _.find(this.templates, { id: document.getElementById('template_id').value });

         let object = {
            ws_id: this.currentWorkspace._id,
            name: this.campaign.name,
            template_id: document.getElementById('template_id').value,
            template_name: currentTemplate.name,
            phone_id: document.getElementById('phone_id').value,
            message: this.campaign.message,
            status: (this.campaign.scheduled == 'Now') ? 'Pending' : 'Pending',
            scheduled: this.campaign.scheduled,
            contacts_segment: 'All Contacts'
         }
         
         console.log(object);

         supabase.from('campaigns').upsert([object]).then(result => {

            this.campaigns.push(object);
            
               this.modals.campaign = false;
               iziToast.success({
                  position: 'bottomCenter',
                  title:  'Campaign successfully created.'
               });
          })
          .catch(error => {
            
            console.error(error)
          });

      }
   },
   mounted(){


      if(!localStorage.getItem("juphy_onboarding_campaign")){
         window.Intercom("showArticle", 7882645);
         localStorage.setItem("juphy_onboarding_campaign", "true");
      }

      //const { data, error } = this.supabase.query('SELECT * FROM contacts');

      supabase.from('campaigns').select('*').eq('ws_id', this.currentWorkspace._id).then(result => {
            //this.setContacts(result)
            // Handle successful insertion
            //this.setContacts(result.data)
            if(!result.data){
               this.campaigns = [];
            }else{
               this.campaigns = result.data
            }

            if(!this.campaigns.length){
               this.openTemplates()
            }
            
          })
          .catch(error => {
            // Handle insertion error
            console.error(error)
          });

   }
}

</script>

<template>


   <div class="ui grid">
      <div class="sixteen wide column centered">


         <div v-if="modals.details " class="modalWrapper">
<div @click="modals.details = false" class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">
      <div  class="ui grid centered stackable">
        <div style="padding-top:0; padding-bottom:0; padding-right:0;" class="eight wide column" >
          <div  @click="modals.details = false"  class="ui basic segment right aligned">
            <a style="background: rgba(0,0,0,0.6); position:relative; z-index:999999" class="ui black mini button">Close [ESC]</a>
          </div>
        </div>
      </div>
  <div class="ui grid centered stackable">
        <div style="background: rgba(18, 18, 18, 0.86); z-index: 9999;border-radius: 10px;" class="eight wide column">
         <h3 style="color: white;" class="ui header">Marketing</h3>
         <div  class="ui stackable equal width grid">
                  <div class="column">
                  <div class="reportCard blueLish">
                  <div style="display: inline-block;">
                  <span style="font-size: 30px">0</span> 
                     <p>Sent</p>
                  </div>
                  <i style="float: right;" class="send large icon"></i>
                  </div>
               </div>
               <div class="column">
                  <div class="reportCard gecLish">
                  <div style="display: inline-block;">
                  <span style="font-size: 30px">0</span> 
                     <p>Delivered</p>
                  </div>
                  <i style="float: right;" class="check large icon"></i>
                  </div>
               </div>
               <div class="column">
                  <div class="reportCard purplish">
                  <div style="display: inline-block;">
                  <span style="font-size: 30px">0</span> 
                     <p>Opened/Viewed</p>
                  </div>
                  <i style="float: right;" class="eye large icon"></i>
                  </div>
               </div>
            </div>

      <h3 style="color: white;" class="ui header">Sales</h3>
         <div  class="ui stackable equal width grid">
                  <div class="column">
                  <div class="reportCard purplish">
                  <div style="display: inline-block;">
                  <span style="font-size: 30px">0</span> 
                     <p>Clicked</p>
                  </div>
                  <i style="float: right;" class="hand pointer outline large icon"></i>
                  </div>
               </div>
               <div class="column">
                  <div class="reportCard orangeLish">
                  <div style="display: inline-block;">
                  <span style="font-size: 30px">0</span> 
                     <p>Cart</p>
                  </div>
                  <i style="float: right;" class="cart large icon"></i>
                  </div>
               </div>
               <div class="column">
                  <div class="reportCard greenlish">
                  <div style="display: inline-block;">
                  <span style="font-size: 30px">0</span> 
                     <p>Purchased</p>
                  </div>
                  <i style="float: right;" class="dollar sign large icon"></i>
                  </div>
               </div>
            </div>

        </div>
    </div>
    </div>
    </div>

<div v-if="modals.campaign " class="modalWrapper">
<div @click="modals.campaign = false" class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">
      <div  class="ui grid centered stackable">
        <div style="padding-top:0; padding-bottom:0; padding-right:0;" class="eight wide column" >
          <div  @click="modals.campaign = false"  class="ui basic segment right aligned">
            <a style="background: rgba(0,0,0,0.6); position:relative; z-index:999999" class="ui black mini button">Close [ESC]</a>
          </div>
        </div>
      </div>
  <div class="ui grid centered stackable">
        <div style="background: rgba(0,0,0,.06);z-index: 9999;border-radius: 10px;" class="eight wide column">
        <div class="ui grid">
        <div style="padding-bottom: 0;" class="row">
          <div class="sixteen wide column">

            <div style="background: #f5f5f5; border-bottom: 1px solid #e9e9e9; border-radius: 3px 3px 0 0;" class="ui basic segment">
            <div class="ui info message">
            <i class="icon warning"></i>
            Broadcasting feature is only available for WhatsApp.
            </div>
            
            <div class="ui form">
               <div class="field">
                  <label for="template_id">Select Phone Number</label>
                  <select class="ui fluid dropdown" name="template_id" id="phone_id">
                     <option v-for="(number, i) in numbers" :key="i" :value="number._id">
                     {{number.name}}
                  </option>
                  </select>
            </div>
            <div class="fields">
               <div class="ten wide field">
                  <label for="segment">Segment</label>
                  <select class="ui fluid dropdown" name="contacts" id="segment">
                     <option>All Contacts</option>
                  </select>
               </div>
               <div class="six wide field">
                  <label for="segment">Schedule</label>
                  <select class="ui fluid dropdown" v-model="campaign.scheduled" name="contacts" id="segment">
                     <option>Now</option>
                  </select>
               </div>
            </div>
            <div class="field">
                  <label for="template_id">Select a message template</label>
                  <select class="ui fluid dropdown" name="template_id" id="template_id">
                     <option v-for="(template, i) in templates" :key="i" :value="template.id">
                     {{template.name}}
                  </option>
                  </select>
            </div>
            <div tabindex="0" style="position: relative; z-index: 1;" class="fields">
               <div class="five wide field">
               <label for="platform">Platform</label>
               <select class="ui fluid dropdown" name="platform" id="platform">
                  <option>WhatsApp</option>
               </select>
               </div>
               <div class="eleven wide field">
               <label for="">Campaign Name</label>
               <input v-model="campaign.name" type="text" placeholder="A Special Day Campaign.">
               </div>
            </div>
         </div>

	         <button @click="createCampaign()" class="ui fluid black icon button" type="button" ><i class="send icon"></i> Create Campaign</button>

            </div>
          </div>
        </div>
        </div>
        </div>
    </div>
    </div>
    </div>

         <div style=" background: #f1f1f1; margin: -1rem -1rem 1rem -1rem;" class="ui grid">
         <div class="twelve wide column">
            <div @click="openTemplates()" class="ui teal button float left">New Campaign</div>
         </div>
         <div class="four wide column right aligned">
         </div>
         </div>

         <table v-if="campaigns.length" class="ui celled table">
         <thead>
            <tr>
               <th>Name</th>
               <th>Segment</th>
               <th>Scheduled</th>
               <th>Status</th>
               <th></th>
            </tr>
         </thead>
         <tbody>
            <tr v-for="(campaign, i) in campaigns" :key="campaign.email">
               <td data-label="Name">
                  <h4 class="ui image header">
                     <div class="content">
                        {{campaign.name}}
                        <div class="sub header">
                           <!-- {{au.username}} -->
                     </div>
                  </div>
                  </h4>
               </td>
               <td data-label="Segment">{{campaign.contacts_segment}}</td>
               <td data-label="Date">{{campaign.scheduled}}</td>
               <td data-label="Status">
                  <span v-if="campaign.scheduled !== 'Now'" class="ui orange label">{{campaign.status}}</span>
                  <span v-if="campaign.scheduled == 'Now'" class="ui orange label">{{campaign.status}}</span>
                  
               </td>
               <td>
                  <div @click="campaignResults()" class="ui fluid icon button"> <i class="chart bar icon"></i> <b>View Reports</b> </div>
               </td>
            </tr>
         </tbody>
         </table>
      </div>
   </div>


</template>


<style scoped>

.reportCard{
    padding: 1rem;
    border-radius: 5px;
    color: rgba(255,255,255, 0.9);
  }

  .yellowLish{
background-image: radial-gradient( circle farthest-corner at 46.6% 51.1%,  rgba(255,146,139,1) 0%, rgba(255,172,129,1) 90% );
  }
  .blueLish{
background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(75,108,183,1) 0%, rgba(55,82,141,1) 90% );
  }
  .greenLish{
   background-image: radial-gradient( circle 347px at -1.2% 12%, rgb(44, 184, 168) 0%, rgb(240, 230, 142) 50% );
  }
  .geclish{
background-image: radial-gradient( circle 1027px at -1.2% 102%, #37528d 0%, #a16eed 30% )
  }
  .purpLish{
    background-image: linear-gradient( 109.6deg,  rgba(119,44,232,0.68) 11.5%, rgba(119,44,232,1) 91.2% );
  }
  .orangeLish{
    background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(255,122,78,1) 0%, rgba(255,205,112,1) 90% );
  }

.front{
  box-shadow: rgb(224, 224, 224) 0px 2px 4px !important;
  border-radius: 5px !important;
  background: #ffffff !important;
}

.active{
   font-weight:bold !important;
}
.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 9999; 
   overflow: hidden;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.65) none repeat scroll 0% 0%; 
   z-index: 9999; 
   overflow: hidden;
}

.shadow{
   box-shadow: 0px 2px 54px rgba(99, 99, 99, 0.85);
   border: none;
   background: #eee;
}
</style>





// WEBPACK FOOTER //
// src/components/dashboard/Campaign.vue